module.exports = {
  "version": "0.24.0"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/env/data.js
// module id = 46
// module chunks = 0